// api
import type { GetAlarmDto } from '@/api/generated/recalc/endpoints/v2/alarms';

export type LegacyAlarmShape = {
  AlarmId?: number;
  AccountId?: number;
  AlarmType?: string | null;
  DataFrom?: string | null;
  DataTo?: string | null;
  AlarmSubtype?: string | null;
  Severity?: string;
  Title?: string | null;
  Message?: string | null;
  MetaData?: string | null;
  Details?: string | null;
  State?: string;
  Created?: string;
  StateChanged?: string | null;
  StateHistory?: GetAlarmDto['stateHistory'];
  Associations: {
    Units: number[];
    Buildings: number[];
    JobSubscriptions: number[];
    Sensors: number[];
    Gateways: number[];
    EnergyGroups: number[];
    EnergyInitiatives: number[];
    EnergyTreeNodes: string[];
    DataStreams: NonNullable<GetAlarmDto['associations']>['dataStreams'];
  };
};

export function toLegacyAlarmShape(
  alarm: GetAlarmDto | null | undefined,
): LegacyAlarmShape | null {
  if (!alarm) return null;

  return {
    AlarmId: alarm.alarmId,
    AccountId: alarm.accountId,
    AlarmType: alarm.alarmType,
    DataFrom: alarm.dataFrom,
    DataTo: alarm.dataTo,
    AlarmSubtype: alarm.alarmSubtype,
    Severity: alarm.severity,
    Title: alarm.title,
    Message: alarm.message,
    MetaData: alarm.metaData,
    Details: alarm.details,
    State: alarm.state,
    Created: alarm.created,
    StateChanged: alarm.stateChanged,
    StateHistory: alarm.stateHistory,
    Associations: {
      Units:
        alarm.associations?.units
          ?.map((item) => item?.id)
          .filter((id): id is number => typeof id === 'number') || [],
      Buildings:
        alarm.associations?.buildings
          ?.map((item) => item?.id)
          .filter((id): id is number => typeof id === 'number') || [],
      JobSubscriptions:
        alarm.associations?.jobSubscriptions
          ?.map((item) => item?.id)
          .filter((id): id is number => typeof id === 'number') || [],
      Sensors:
        alarm.associations?.sensors
          ?.map((item) => item?.id)
          .filter((id): id is number => typeof id === 'number') || [],
      Gateways:
        alarm.associations?.gateways
          ?.map((item) => item?.id)
          .filter((id): id is number => typeof id === 'number') || [],
      EnergyGroups:
        alarm.associations?.energyGroups
          ?.map((item) => item?.id)
          .filter((id): id is number => typeof id === 'number') || [],
      EnergyInitiatives:
        alarm.associations?.energyInitiatives
          ?.map((item) => item?.id)
          .filter((id): id is number => typeof id === 'number') || [],
      EnergyTreeNodes:
        alarm.associations?.energyTreeNodes
          ?.map((item) => item?.id)
          .filter((id): id is string => typeof id === 'string') || [],
      DataStreams: alarm.associations?.dataStreams || [],
    },
  };
}
